import { ReactComponent as Icon } from "../files/back-arrow.svg";

import ISVGIconProps from "../ISVGIconProps";

const BackArrowIcon = ({ fill, style = {} }: ISVGIconProps) => {
    return <Icon fill={fill} style={style} />;
};

export default BackArrowIcon;
